import { useState } from 'react';

const areasAtuacao = [
  { 
    title: "Acidente de trabalho",
    icon: "fa-solid fa-first-aid"
  },
  { 
    title: "Doença ocupacional",
    icon: "fa-solid fa-virus"
  },
  { 
    title: "Insalubridade e Periculosidade",
    icon: "fa-solid fa-radiation"
  },
  { 
    title: "Reversão justa causa indevida",
    icon: "fa-solid fa-gavel"
  },
  { 
    title: "Reconhecimento de vínculo",
    icon: "fa-solid fa-handshake"
  },
  { 
    title: "Pedido de demissão forçado",
    icon: "fa-solid fa-user-slash"
  },
  { 
    title: "Horas extras",
    icon: "fa-solid fa-clock"
  },
  { 
    title: "Salários atrasados",
    icon: "fa-solid fa-money-bill-wave"
  },
  { 
    title: "Assédio Moral e Sexual",
    icon: "fa-solid fa-exclamation-triangle"
  },
  { 
    title: "Rescisão do Contrato",
    icon: "fa-solid fa-file-contract"
  },
  { 
    title: "Discriminação no trabalho",
    icon: "fa-solid fa-balance-scale"
  },
];

export default function Habilidades() {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <section style={{ 
      background: 'var(--dark-gray)',
      padding: '4rem 2rem'
    }}>
      <h2 className="section-title" style={{
        textAlign: 'center',
        fontSize: '2.5rem',
        marginBottom: '3rem',
        position: 'relative'
      }}>Áreas de Atuação</h2>
      
      <div style={{ 
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        flexWrap: 'wrap',
        gap: '1.5rem',
        justifyContent: 'center'
      }}>
        {areasAtuacao.map((area, index) => (
          <div 
            key={index} 
            style={{ 
              background: hoveredIndex === index ? 'var(--accent)' : 'rgba(255, 255, 255, 0.03)',
              borderRadius: '10px',
              padding: '1.5rem',
              width: '220px',
              height: '180px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
              position: 'relative',
              overflow: 'hidden',
              boxShadow: hoveredIndex === index 
                ? '0 15px 35px rgba(var(--accent-rgb), 0.2)' 
                : '0 5px 15px rgba(0, 0, 0, 0.1)',
              transform: hoveredIndex === index ? 'translateY(-15px)' : 'translateY(0)'
            }}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            <div style={{
              fontSize: '2.5rem',
              color: hoveredIndex === index ? 'black' : 'var(--accent)',
              marginBottom: '1rem',
              transition: 'all 0.3s ease'
            }}>
              <i className={area.icon}></i>
            </div>
            
            <h3 style={{
              fontSize: '1rem',
              fontWeight: '500',
              textAlign: 'center',
              color: hoveredIndex === index ? 'black' : 'var(--text-color)',
              margin: '0',
              transition: 'all 0.3s ease',
              lineHeight: '1.4'
            }}>
              {area.title}
            </h3>
            
            {hoveredIndex === index && (
              <div style={{
                position: 'absolute',
                bottom: '-10px',
                right: '-10px',
                width: '100px',
                height: '100px',
                borderRadius: '50%',
                background: 'rgba(255, 255, 255, 0.1)',
                zIndex: 0,
                animation: 'pulse 2s infinite'
              }}></div>
            )}
          </div>
        ))}
      </div>
      
      <style jsx>{`
        @keyframes pulse {
          0% { transform: scale(1); opacity: 0.8; }
          50% { transform: scale(1.3); opacity: 0.4; }
          100% { transform: scale(1); opacity: 0.8; }
        }
        
        .section-title::after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 80px;
          height: 3px;
          background: var(--accent);
        }
      `}</style>
    </section>
  );
}